import src from "IMAGE";
export default { src, width: 50, height: 51, blurWidth: 0, blurHeight: 0};
